import { env } from '@powerbox/shared/utils/envVariables'

const noscript = env.GTM_NOSCRIPT
const noscriptHtml = { __html: noscript || '' }

export function GtmNoScript() {
  if (noscript) {
    return <noscript dangerouslySetInnerHTML={noscriptHtml} />
  }
  return null
}
